import PropTypes from 'prop-types';
import { HiOutlineListBullet, HiOutlineSquares2X2 } from 'react-icons/hi2';

const MODES = [
	{ key: 'grid', icon: HiOutlineSquares2X2, label: 'Rasteransicht' },
	{ key: 'list', icon: HiOutlineListBullet, label: 'Listenansicht' },
];

const ViewModeToggle = ({ value, onChange }) => (
	<div className="flex items-center gap-1" role="group" aria-label="Ansicht wählen">
		{MODES.map(({ key, icon: Icon, label }) => {
			const isActive = value === key;
			return (
				<button
					key={key}
					type="button"
					title={label}
					aria-label={label}
					aria-pressed={isActive}
					onClick={() => onChange(key)}
					className={`grid h-8 w-8 place-items-center rounded-control transition-colors ${
						isActive ? 'text-primary-500' : 'text-bgBase-600 hover:text-primary-500'
					}`}
				>
					<Icon className="h-6 w-6" />
				</button>
			);
		})}
	</div>
);

ViewModeToggle.propTypes = {
	value: PropTypes.oneOf(['grid', 'list']).isRequired,
	onChange: PropTypes.func.isRequired,
};

export default ViewModeToggle;
